import React from "react";
import BuildingList from "./buildinglist";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import ListPage from "./components/List/ListPage";

const Building = () => {
  return (
    <NavHeightAdjust>
      <ListPage />
    </NavHeightAdjust>
  );
};

export default Building;
